import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { Location } from "@angular/common";
import { RouterHelperService } from "../../services/routerHelper.service";
import { Router } from "@angular/router";
import { CoreLogService } from "../../services/log.service";

@Component({
  selector: "ya-subheader",
  templateUrl: "./subheader.component.html",
  styleUrls: ["./subheader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubheaderComponent implements OnInit, AfterViewInit {
  @Input() hasContent: boolean = false;
  @Input() disableNavigateBack: boolean = false;
  @Input() enableNavigateBackButton: boolean = true;
  @Input() useNavigateData: boolean = false;
  @Output() onNavigateBackClick = new EventEmitter<void>();
  constructor(private _routerHelperService: RouterHelperService
    , private _location: Location
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService) { }

  ngAfterViewInit(): void {
    const me = this;
    // me.PushChanges();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SubheaderComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
  }

  public navigateBack(): void {
    const me = this;
    if (me.useNavigateData) {
      me._routerHelperService.navigateBackSimple();
    } else if (me.disableNavigateBack) {
      me.onNavigateBackClick.emit();
    } else {
      me._location.back();
    }
  }

}
